import { render, staticRenderFns } from "./AzconTabBar.vue?vue&type=template&id=2cb0b94e&scoped=true"
import script from "./AzconTabBar.vue?vue&type=script&lang=js"
export * from "./AzconTabBar.vue?vue&type=script&lang=js"
import style0 from "./AzconTabBar.vue?vue&type=style&index=0&id=2cb0b94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0b94e",
  null
  
)

export default component.exports